import React, {useEffect, useMemo, useState} from 'react'
import {eventosOrdinariosFields} from "./eventos-ordinarios-fields"
import {Stack} from "@mui/material"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import MotorEventosOrdinariosService from "../../../../../../../services/motor-eventos-ordinarios-service"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import {mapEventosOrdinariosToTable} from "./map-eventos-ordinarios"
import {useLocation} from "react-router-dom"

const EventosOrdinariosTable = (
    {
        setLoading,
        idCaracteristica,
        eventoPublicado,
        tableData,
        jurosOptions,
        setTableData,
        clearTable
    }) => {
    const eventosService = useMemo(() => new MotorEventosOrdinariosService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        const {origem} = navigationState
        if (origem === undefined || origem === "ver" && idCaracteristica !== undefined) {
            loadEventosOrdinarios()
        }
    }, [idCaracteristica])

    useEffect(() => {
        const {origem} = navigationState
        if (origem === "duplicar") {
            const {Data, CETIP, VersaoDocumento} = navigationState
            const {EventosOrdinarios} = Data
            if (EventosOrdinarios !== null) {
                const {Caracteristica} = Data
                const {Caracteristica: {IDEmissao}} = Caracteristica
                setTableData(mapEventosOrdinariosToTable(EventosOrdinarios, CETIP, VersaoDocumento, IDEmissao))
                setTableKey(Math.random() * 10)
            }
        }
    }, [])

    useEffect(() => {
        console.log("tableData", tableData)
        if(tableData !== null) {
            setTableData(tableData)
        }
    }, [])

    const loadEventosOrdinarios = () => {
        setLoading(true)
        eventosService.getEventosOrdinarios(idCaracteristica)
            .then(response => {
                const {body} = response

                if (body && body.length > 0) {
                    eventoPublicado(true)
                    const formatted = mapEventosOrdinariosToTable(body)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    loadEventosOrdinariosTemporario()
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    const loadEventosOrdinariosTemporario = () => {
        eventosService.getTemporarioEventosOrdinarios(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body?.Eventos || response?.data?.Eventos

                if (bodyTemp && bodyTemp.length > 0) {
                    eventoPublicado(false)
                    const formatted = mapEventosOrdinariosToTable(bodyTemp)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    const copyDataEventosOrdinarios = () => {
        const data = tableData.map((item) =>
            Object.fromEntries(
                Object.entries(item).map(([key, value]) => {
                    if (typeof value === "number") {
                        return [key, value.toString().replace(".", ",")]
                    }

                    if (typeof value === "string" && /^-?\d+\.\d+$/.test(value)) {
                        return [key, value.replace(".", ",")]
                    }

                    return [key, value]
                })
            )
        )

        copyTable(data, eventosOrdinariosFields(jurosOptions))
    }

    const normalizeCommaToDot = (rows) =>
        rows.map((item) =>
            Object.fromEntries(
                Object.entries(item).map(([key, value]) => {
                    if (
                        typeof value === "string" &&
                        /^-?\d+,\d+$/.test(value.trim())
                    ) {
                        return [key, value.trim().replace(",", ".")]
                    }

                    return [key, value]
                })
            )
        )

    const pasteDataEventosOrdinario = async () => {
        await pasteTableFromClipboard(
            eventosOrdinariosFields(jurosOptions),
            (payload) => {
                const rows = Array.isArray(payload)
                    ? payload
                    : payload?.data ?? []

                setTableData(normalizeCommaToDot(rows))
            }
        )
    }

    return <Stack sx={{mt: 0}}>
        <DynamicColumnTable
            key={tableKey}
            height={600}
            actionButtons={true}
            copyData={() => copyDataEventosOrdinarios()}
            clearTable={() => clearTable(setTableData)}
            pasteData={pasteDataEventosOrdinario}
            fields={eventosOrdinariosFields(jurosOptions)}
            items={tableData}
            setItems={setTableData}
        />
    </Stack>
}

EventosOrdinariosTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    eventoPublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    jurosOptions: PropTypes.array,
    clearTable: PropTypes.func,
}

export default EventosOrdinariosTable